module.exports = __webpack_public_path__ + "img/pichu-min.3d397b88.png";